import { z } from 'zod';

export const WidgetCategory = z.enum([
  'alerts',
  'goals',
  'chat',
  'games',
  'media',
  'static',
  'metrics',
  'custom',
]);
export type WidgetCategory = z.infer<typeof WidgetCategory>;

export const WidgetTransform = z.object({
  x: z.number(),
  y: z.number(),
  w: z.number().positive(),
  h: z.number().positive(),
  rotation: z.number().default(0),
  opacity: z.number().min(0).max(1).default(1),
  zIndex: z.number().int().default(0),
  locked: z.boolean().default(false),
  hidden: z.boolean().default(false),
});
export type WidgetTransform = z.infer<typeof WidgetTransform>;

export const WidgetInstance = z.object({
  id: z.string().uuid(),
  widgetType: z.string(),
  transform: WidgetTransform,
  fields: z.record(z.string(), z.unknown()),
});
export type WidgetInstance = z.infer<typeof WidgetInstance>;

export const Scene = z.object({
  id: z.string().uuid(),
  name: z.string(),
  widgets: z.array(WidgetInstance),
});
export type Scene = z.infer<typeof Scene>;

export const Overlay = z.object({
  id: z.string().uuid(),
  name: z.string(),
  width: z.number().int().positive().default(1920),
  height: z.number().int().positive().default(1080),
  scenes: z.array(Scene),
  activeSceneId: z.string().uuid(),
  version: z.number().int().nonnegative().default(0),
});
export type Overlay = z.infer<typeof Overlay>;
